import {AfterViewInit, Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import { SafeHtml } from '@angular/platform-browser'
import { ModalDirective } from 'ngx-bootstrap/modal';
import { ModalConfig } from './modal-config';
import {ThemePalette} from "@angular/material/core";

@Component({
  selector: 'modal-component',
  templateUrl: './modal.component.html',
  styleUrls: [ './modal.component.scss' ]
})
export class ModalComponent implements AfterViewInit {

  @ViewChild('modalComponent') private modal: ModalDirective;
  @Output('accept') private onAccept = new EventEmitter<any>();
  @Output('reject') private onReject = new EventEmitter<any>();
  @Output('reprocess') readonly onReprocess = new EventEmitter<any>();
  @Output('confirmReprocess') readonly onConfirmReprocess = new EventEmitter<any>();
  @Output('edit') readonly onEdit = new EventEmitter<any>();
  @Output('resubmit') readonly onResubmit = new EventEmitter<any>();
  @Input('data') private templateConfig: ModalConfig;
  @Input() public title: string;
  @Input() private content: SafeHtml;

  @Input() private colorTheme : ThemePalette = 'primary';

  public config: ModalConfig = {
    backdrop: 'static',
    keyboard: false,
    focus: false,
    show: false,
    ignoreBackdropClick: true,
    small: false,
    resizeOrClose: 'resize',
    okBtnTitle: '',
    okBtnAutoHide: true,
    okBtnCssClass: '',
    cancelBtnTitle: '',
    cancelBtnAutoHide: true,
    cancelBtnCssClass: '',
    editable: false,
    editBtnTitle: '',
    editBtnAutoHide: true,
    editBtnCssClass: '',
    showSpinner: false,
    spinnerCssClass: '',
    spinnerColorTheme: this.colorTheme,
    reprocessBtnTitle: '',
    reprocessable: false
  };
  private payload: any;

  ngAfterViewInit() {
    this.modal.onShown.subscribe(() => {
      document.querySelectorAll(".modal-body").forEach(modal => modal.scrollTop = 0);
      document.querySelectorAll("#source-content").forEach(source => source.scrollIntoView());
    })
  }

  public accept(): void {
    this.onAccept.emit(this.payload);
    if(this.config.okBtnAutoHide === true) {
      this.modal.hide();
    }
  }

  public reject(): void {
    this.onReject.emit(this.payload);
    if (this.config.cancelBtnAutoHide === true) {
      this.modal.hide();
    }
  }

  public edit(): void {
    this.onEdit.emit(this.payload);
  }

  public resubmit(): void {
    this.onResubmit.emit(this.payload);
    if (this.config.resubmitBtnAutoHide === true) {
      this.modal.hide();
    }
  }


    public reprocess(): void {
        this.onReprocess.emit(this.payload);
    }

    public confirmReprocess(): void {
        this.onConfirmReprocess.emit(this.payload);
    }

    // Optional method for setting the button text.  Can also be set in the
  // <modal-component> in the html file.  Note that setting it in the html
  // file causes this function to become inoperative.
  public cancelButtonTitle(title: string) {
      this.config.cancelBtnTitle = title;
  }

  public resubmitButtonTitle(title: string) {
      this.config.resubmitBtnTitle = title;
  }

  public reprocessButtonTitle(title: string) {
      this.config.reprocessBtnTitle = title;
  }

    // Optional method for setting the button text.  Can also be set in the
  // <modal-component> in the html file.  Note that setting it in the html
  // file causes this function to become inoperative.
  public okButtonTitle(title: string) {
      this.config.okBtnTitle = title;
  }

  public editButtonTitle(title: string) {
      this.config.editBtnTitle = title;
  }

  public triggerEdit(editable: boolean) {
      this.config.editable = editable;
  }

  public triggerReprocess(reprocessable: boolean) {
      this.config.reprocessable = reprocessable;
  }

  public triggerSpinner(showSpinner: boolean) {
    this.config.showSpinner = showSpinner;
  }

  public open(config?: ModalConfig, payload ?: any): void {
    this._init(config, payload);
    this.modal.show();
  }

  public close(config?: ModalConfig, payload ?: any): void {
    this._init(config, payload);
    this.modal.hide();
  }

  public closeNow(config?: ModalConfig, payload ?: any): void {
    this.modal.hide();
  }

  public resize(): void {
    this.config.small = !this.config.small;
  }
  public small(small: boolean): void {
    this.config.small = small;
  }

  private  _init(modalConfig: ModalConfig, payload: any): void {
    let config = Object.assign(this.config, this.templateConfig, modalConfig);
    this.config = config;
    this.modal.config = config;
    this.payload = payload || null;
  }
}
